<template>
  <div class="d-flex justify-content-end mr-3 grid-display-options">
    <div class="d-flex align-items-center mr-2">
      <label class="filter-label tertiary-color m-0 mr-2 d-none d-md-block">{{ $t('global.pageSize') }}:</label>
      <vt-combo-select
        id="requestsPageSizeSelect"
        v-model="pageSize"
        v-testing="'page-size-select'"
        :searchable="false"
        :allow-empty="false"
        label="value"
        track-by="value"
        class="multiselect--small mb-0"
        :options="pageSizeOptions"
        @input="changedPageSize"
      />
    </div>

    <div class="mr-2 d-flex align-items-center">
      <vt-combo-select
        v-model="mode"
        v-testing="'mode-select'"
        class="multiselect--small mb-0"
        :allow-empty="false"
        :searchable="false"
        :options="options"
        :option-height="20"
        :show-labels="false"
        track-by="value"
        @select="changedMode"
      >
        <template #singleLabel="{ option }">
          <i
            :class="option.icon"
            aria-hidden="true"
          />
        </template>
        <template #option="{ option }">
          <i
            :class="option.icon"
            aria-hidden="true"
          />
        </template>
      </vt-combo-select>
    </div>
  </div>
</template>

<script>
import customConfigResource from '@/api/resources/ui/CustomConfigResource'

export default {
    name: 'GridDisplayOptions',
    props: {
        uiComponent: { type: String },
        sizePage: { type: Number }
    },
    data() {
        return {
            options: [
                { value: 'compact', icon: 'fal fa-align-justify', size: 25 },
                { value: 'normal', icon: 'fal fa-bars', size: 40 }
            ],
            pageSizeOptions: [
                { value: 20 },
                { value: 50 },
                { value: 100 }
            ],
            mode: { value: 'compact', icon: 'fal fa-align-justify' },
            pageSize: { value: 20 },
            customConfig: {}
        }
    },
    created() {
        this.loadCustomConfig()
    },
    methods: {
        async changedMode(mode) {
            this.customConfig.config = {
                gridPageSize: this.customConfig.config?.gridPageSize,
                gridMode: mode
            }
            if (this.uiComponent) {
                await this.saveCustomConfig()
            }
            this.$emit('changedMode', mode)
        },
        async changedPageSize(pageSize) {
            this.customConfig.config = {
                gridMode: this.customConfig.config?.gridMode,
                gridPageSize: pageSize.value
            }
            if (this.uiComponent) {
                await this.saveCustomConfig()
            }
            this.$emit('changedPageSize', pageSize.value)
        },
        async loadCustomConfig() {
            if (this.uiComponent) {
                const currentCustomConfig = await this.$_toCallSecure(customConfigResource.get(this.uiComponent))
                if (currentCustomConfig) {
                    this.customConfig = currentCustomConfig
                    if (!this.$_isEmpty(this.customConfig)) {
                        if (this.customConfig.config?.gridPageSize) {
                            this.pageSize.value = this.customConfig.config.gridPageSize
                            this.$emit('changedPageSize', this.pageSize.value)
                        }
                        if (this.customConfig.config?.gridMode) {
                            this.mode = this.customConfig.config.gridMode
                            this.$emit('changedMode', this.mode)
                        }
                    }
                }
            } else {
                if (this.sizePage >= 0) {
                    this.pageSize.value = this.sizePage
                }
            }
        },
        async saveCustomConfig() {
            await this.$_adviceSaveUiComponent(this.uiComponent, this.customConfig.config)
        }
    }
}
</script>
